import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { FORMAT_DATE_BACK, formatDate, isEmpty, postSubmit, scrollToComponent, stringToDate } from "@ui-seeker/utils"

import { useProductPageKpiRoleConfig } from "../../@hooks"
import { evolutionDataFilters } from "../../@signals"


export default function useProductPagesKpiEvolution() {
	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal([])
	const selectData = useSignal([])
    const dateRange = useSignal([])
	const isLoadingDataEvolution = useSignal(false)
	const { showToast } = useAppToast()
	const { urlApiEvolution} = useProductPageKpiRoleConfig()

	useEffect(() => {
		if (!isEmpty(evolutionDataFilters.value)) batch(() => {
			dataEvolution.value = []
			isLoadingDataEvolution.value = true
			showToast.promise(postSubmit(urlApiEvolution, evolutionDataFilters).then(res => {
				dataEvolution.value = res.chart
				dataEvolutionKeys.value = res.chartKeys
				selectData.value = res.selectData
                dateRange.value = [stringToDate(evolutionDataFilters.value.startDate), stringToDate(evolutionDataFilters.value.endDate)]
			}).catch(() => showToast.error()
			).finally(() => {
				window.scrollTo(0, document.body.scrollHeight)
				isLoadingDataEvolution.value = false
			}))
		})

		if (isEmpty(evolutionDataFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = []
			selectData.value = []
		})

	}, [JSON.stringify(evolutionDataFilters.value)]);

	const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		evolutionDataFilters.value = {}
		selectData.value = []
		scrollToComponent('kpi-table')
	})

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            evolutionDataFilters.value = {
                ...evolutionDataFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		selectData: selectData.value,
        dateRange: dateRange.value,

        onChange,
		resetEvolutionData
	}
}